import { Badge } from "antd";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
	AntdButton,
	ButtonContainer,
	ChildrenContainer,
	DetailPanel,
	Inner,
	PageHeader,
	PageSub,
	PageTitle,
	Section,
	Shell,
	Sidebar,
	SidebarBadge,
	SidebarIcon,
	SidebarItem,
	SidebarLabel,
	SidebarSectionLabel,
} from "./styles";
import Main from "../../../layout/main/Main";
import { useFilter } from "../../../../contexts/filterContext";
import { CONSTANTS } from "../../../../utils/constants";
import ModuleOneTransfer from "./components/module-one-transfer/ModuleOneTransfer";
import ModuleErp from "./components/module-erp/ModuleErp";
import { useAuth } from "../../../../contexts/authContext";
import {
	AppstoreOutlined,
	DatabaseOutlined,
	GlobalOutlined,
} from "@ant-design/icons";
import {
	MdBusinessCenter,
	MdFormatListBulleted,
	MdMobileScreenShare,
	MdPanoramaPhotosphere,
} from "react-icons/md";
import { GiArtificialIntelligence } from "react-icons/gi";

export default function MarketGeneralConfig({ userdata }) {
	const {
		generalConfigOT,
		setGeneralConfigOT,
		userRol,
		checkposSection,
		setCheckposSection,
		erpSection,
		setErpSection,
	} = useFilter();
	const { toValidateQty, agentOrdersQty } = useAuth();

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	return (
		<Main>
			<Main.Header style={{ padding: "0 82px" }}>
				<Main.Breadcrumb>
					<Main.BreadcrumbItem>
						<Link to="/">Home</Link>
					</Main.BreadcrumbItem>
					<Main.BreadcrumbSeparator />
					<Main.ActiveBreadcrumbItem>
						Configuración General
					</Main.ActiveBreadcrumbItem>
				</Main.Breadcrumb>
			</Main.Header>

			<Inner>
				<PageHeader>
					<Section>
						<PageTitle>Configuración General</PageTitle>
						<PageSub>Administrá los parámetros del sistema</PageSub>
					</Section>

					<ButtonContainer>
						{((userdata.p_client && userdata.p_users) ||
							(userdata.p_client && !userdata.p_users)) && (
							<Badge
								count={toValidateQty + agentOrdersQty}
								offset={[-2, 4]}
								size="small"
								color="#E24B4A"
							>
								<AntdButton
									onClick={() =>
										setGeneralConfigOT(CONSTANTS.MODULE_ONE_TRANSFER)
									}
									$active={generalConfigOT === CONSTANTS.MODULE_ONE_TRANSFER}
								>
									Checkpos Transfer
								</AntdButton>
							</Badge>
						)}

						<AntdButton
							onClick={() => setGeneralConfigOT(CONSTANTS.MODULE_ERP)}
							$active={generalConfigOT === CONSTANTS.MODULE_ERP}
						>
							ERP
						</AntdButton>
					</ButtonContainer>
				</PageHeader>

				<Shell>
					<Sidebar>
						<SidebarSectionLabel>
							{generalConfigOT === CONSTANTS.MODULE_ONE_TRANSFER
								? "Checkpos Transfer"
								: "ERP"}
						</SidebarSectionLabel>

						{generalConfigOT === CONSTANTS.MODULE_ONE_TRANSFER ? (
							<>
								<SidebarItem
									$active={checkposSection === "general"}
									onClick={() => setCheckposSection("general")}
								>
									<SidebarIcon $active={checkposSection === "general"}>
										<DatabaseOutlined />
									</SidebarIcon>
									<SidebarLabel>Configuración General</SidebarLabel>
								</SidebarItem>

								{userdata.p_client &&
									userdata.p_products &&
									userdata.p_dashboard && (
										<SidebarItem
											$active={checkposSection === "pdvGeneral"}
											onClick={() => setCheckposSection("pdvGeneral")}
										>
											<SidebarIcon $active={checkposSection === "pdvGeneral"}>
												<MdPanoramaPhotosphere size={16} />
											</SidebarIcon>
											<SidebarLabel>Gestión PDV General</SidebarLabel>
											{toValidateQty > 0 && (
												<SidebarBadge>{toValidateQty}</SidebarBadge>
											)}
										</SidebarItem>
									)}

								{userdata.p_client && userdata.p_users && (
									<SidebarItem
										$active={checkposSection === "business"}
										onClick={() => setCheckposSection("business")}
									>
										<SidebarIcon $active={checkposSection === "business"}>
											<MdBusinessCenter size={16} />
										</SidebarIcon>
										<SidebarLabel>Negocio</SidebarLabel>
									</SidebarItem>
								)}

								<SidebarItem
									$active={checkposSection === "ia"}
									onClick={() => setCheckposSection("ia")}
								>
									<SidebarIcon $active={checkposSection === "ia"}>
										<GiArtificialIntelligence size={16} />
									</SidebarIcon>
									<SidebarLabel>IA</SidebarLabel>
									{agentOrdersQty > 0 && (
										<SidebarBadge>{agentOrdersQty}</SidebarBadge>
									)}
								</SidebarItem>
							</>
						) : (
							<>
								<SidebarItem
									$active={erpSection === "general"}
									onClick={() => setErpSection("general")}
								>
									<SidebarIcon $active={erpSection === "general"}>
										<GlobalOutlined />
									</SidebarIcon>
									<SidebarLabel>Configuración General</SidebarLabel>
								</SidebarItem>

								<SidebarItem
									$active={erpSection === "products"}
									onClick={() => setErpSection("products")}
								>
									<SidebarIcon $active={erpSection === "products"}>
										<MdFormatListBulleted size={16} />
									</SidebarIcon>
									<SidebarLabel>Gestión de Productos</SidebarLabel>
								</SidebarItem>

								<SidebarItem
									$active={erpSection === "mobile"}
									onClick={() => setErpSection("mobile")}
								>
									<SidebarIcon $active={erpSection === "mobile"}>
										<MdMobileScreenShare size={16} />
									</SidebarIcon>
									<SidebarLabel>Mobile</SidebarLabel>
								</SidebarItem>
							</>
						)}
					</Sidebar>

					<DetailPanel>
						<ChildrenContainer>
							{generalConfigOT === CONSTANTS.MODULE_ONE_TRANSFER &&
								((userdata.p_client && userdata.p_users) ||
									(userdata.p_client && !userdata.p_users)) && (
									<ModuleOneTransfer
										userdata={userdata}
										userRol={userRol}
										toValidateQty={toValidateQty}
										agentOrdersQty={agentOrdersQty}
										activeSection={checkposSection}
									/>
								)}

							{generalConfigOT === CONSTANTS.MODULE_ERP && (
								<ModuleErp
									userdata={userdata}
									userRol={userRol}
									toValidateQty={toValidateQty}
									activeSection={erpSection}
								/>
							)}
						</ChildrenContainer>
					</DetailPanel>
				</Shell>
			</Inner>
		</Main>
	);
}
